export default __webpack_public_path__ + "static/media/alert-circle.e99464d8.svg";